import Vue from "vue";
import App from "./App";
import "./registerServiceWorker";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import Vuelidate from 'vuelidate';
import FlashMessage from '@smartweb/vue-flash-message';
import Axios from '@/http'

Vue.use(Axios);

Vue.use(FlashMessage);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  
  Vuelidate,
  render: (h) => h(App),
}).$mount("#app");
